import OliAxios from 'api/util/OliAxios';
import { getConfig } from 'api/util/getConfig';
import {
  AttorneyListResponseData, AttorneyListResponse,
} from './Attorney.types';

type Methods = 'head' | 'options' | 'put' | 'post' | 'patch' | 'delete' | 'get';

async function getList(token:string | undefined, matterUUID: string | undefined):Promise<undefined | AttorneyListResponseData> {
  if (token) {
    const config = getConfig(token);
    const url = '/attorney/list';
    const params = { matterUuid: matterUUID };
    try {
      const response:AttorneyListResponse = await OliAxios.get(url, {
        ...config, params,
      });
      return response.data;
    } catch (e) {
      console.log("Something went wrong", e); // eslint-disable-line
    }
  }
  return undefined;
}

async function postAttorney(token:string | undefined, action: string, data: Record<string, unknown>):Promise<undefined> {
  if (token) {
    const config = getConfig(token);
    const url = '/attorney/postAttorney';
    const params = {
      action, data,
    };

    let method:Methods;
    switch (action) {
      case 'create':
        method = 'post';
        break;
      case 'delete':
        method = 'delete';
        break;
      case 'update':
        method = 'patch';
        break;
      default:
        method = 'get';
        break;
    }
    try {
      await OliAxios({
        method, url, data: params, ...config,
      });
    } catch (e) {
      console.log("Something went wrong", e); // eslint-disable-line
    }
  }
  return undefined;
}

export {
  getList, postAttorney,
};
